import { render, staticRenderFns } from "./ApartmentCharacters.vue?vue&type=template&id=6e3b7ffc&scoped=true"
import script from "./ApartmentCharacters.vue?vue&type=script&lang=js"
export * from "./ApartmentCharacters.vue?vue&type=script&lang=js"
import style0 from "./ApartmentCharacters.vue?vue&type=style&index=0&id=6e3b7ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3b7ffc",
  null
  
)

export default component.exports